<script>
    import { locale } from 'svelte-i18n'
    import { page } from '$app/stores'
    import SiruLogo from '$lib/images/sirumobile-logo.png'
    import LanguageSwitcher from '$lib/Components/Heading/LanguageSwitcher.svelte'
</script>

<div class="row my-2">
    <div class="col-sm-7 col-5 text-start ml-0">
        <a href={`/${$locale}/${$page.params.country}`}>
            <img src={SiruLogo} class="logo" alt="Siru Mobile" />
        </a>
    </div>
    <div class="col-sm-5 col-7 text-end">
        <LanguageSwitcher />
    </div>
</div>

<style lang="scss">
    img.logo {
        height: 30px;
    }

    a:hover,
    button:hover {
        background-color: #f3f3f3;
        color: #b1b1b1;
    }

    .text-start {
        font-size: 1.4em;
    }

    .text-end {
        a,
        button {
            border-radius: 1em;
            padding: 0.1em 0.4em 0.25em;
            margin-left: 0.2em;
            min-width: 2em;
            color: #b1b1b1;
            border-color: #b1b1b1;
            background-color: transparent;

            :global(svg) {
                font-size: 0.8em;
            }
        }

        button:focus {
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }

        button:hover {
            background-color: #f3f3f3;
            color: #b1b1b1;
            border-color: #b1b1b1;
        }
    }
</style>
